<script>
    
    // -- this whole thing might have to be gated by a can_render flag?, same as tiles probably
    // -- we would like to avoid that id possible but we might have to wait for certain settings to be made
    
    
    import Icon from "./Icon.svelte";
    import Separator from "./Separator.svelte";
    import { Peers_Handler } from "../../Peers";
    import Indicator from './Indicator.svelte';
    import { OutputConfig } from '../../OutputConfig';
    import PeerLabels from './PeerLabels.svelte';
    import BestAudioButton from './BestAudioButton.svelte';

    export let micMuted;
    export let cameraMuted;
    export let monitorMuted;

    export let openChat;
    export let isFullscreen;
    export let handleClick;

</script>


<div class="toolbar">

    {#if !OutputConfig.session.disable_conf}
        <Icon type="microphone" isMuted={micMuted} handleClick={handleClick}/>

        <Indicator meterSource="mic-input" peerType={Peers_Handler.self_peer.type} peerId={Peers_Handler.self_peer.id}/>

        <Icon type="camera" isMuted={cameraMuted} handleClick={handleClick}/>

        {#if !OutputConfig.session.browser.isMobile}
           <Separator/>
        {/if}
    {/if}

    <Icon type="snd/rcv monitor" isMuted={monitorMuted} handleClick={handleClick}/>

    <Indicator meterSource="stream-sum" peerType={Peers_Handler.self_peer.type} peerId={Peers_Handler.self_peer.id}/>

    {#if !OutputConfig.session.disable_conf}
        <Icon type="chat" openChat={openChat} handleClick={handleClick}/>
    {/if}
    <!-- phones go to landscape mode by themselves, everyone else asks for it here -->
    {#if !OutputConfig.session.browser.isPhone}
        <Icon type="fullscreen" isFullscreen={isFullscreen} handleClick={handleClick}/>
    {/if}
    <Icon type="settings" handleClick={handleClick}/>

    {#if !OutputConfig.session.disable_conf}
        <BestAudioButton handleClick={handleClick}/>
    {/if}

    <!-- <Icon type="hangup" handleClick={handleClick}/> -->

    {#if OutputConfig.session.disable_conf}
        <PeerLabels/>
    {/if}

</div>
  
<style lang="scss">
    
    @import "../styles/main.scss";

    .toolbar {

        width: 100%;
        padding: 20px;
        margin-top: 5px;
        border-top: 1px solid rgba(190, 157, 134, 0.12);

        // -- expose toolbar width as a query container so PeerLabels can restyle on wrap (no-conf mode)
        container-type: inline-size;

        display: flex;
        align-items: flex-start;
        gap: 10px;
        flex-wrap: wrap;
        // align-content: flex-end;
    }

    
  
</style>
    